import { ReactNode } from 'react';
import { rbwTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={rbwTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
